import 'aos/dist/aos.css';
export default defineNuxtPlugin(() => { });